import { gql } from '@apollo/client';

export type SignInInput = {
  uUserName: string;
  password: string;
};

export type SignInData = {
  signIn: {
    AccessToken: string;
    IdToken: string;
    RefreshToken: string;
  };
};

export const SIGN_IN_MUTATION = gql`
  mutation SignIn($input: SignInInput!) {
    signIn(input: $input) {
      AccessToken
      IdToken
      RefreshToken
    }
  }
`;

export type SignUpInput = {
  uFirstName: string;
  uLastName: string;
  uEmailId: string;
  uUserName: string;
  password: string;
};

export type SignUpData = {
  signUp: {
    message: string;
    userId: string;
  };
};

export const SIGN_UP_MUTATION = gql`
  mutation SignUp($input: SignUpInput!) {
    signUp(input: $input) {
      message
      userId
    }
  }
`;

export type ChangePasswordInput = {
  oldPassword: string;
  newPassword: string;
};

export type ChangePasswordData = {
  changePassword: {
    message: string;
  };
};

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      message
    }
  }
`;

export type DeleteAccountData = {
  deleteAccount: boolean;
};

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation DeleteAccount($password: String!) {
    deleteAccount(password: $password)
  }
`;

export type ResetPasswordData = {
  resetPassword: boolean | string;
};

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($email: String!, $code: String!, $newPassword: String!) {
    resetPassword(email: $email, code: $code, newPassword: $newPassword)
  }
`;

export type ValidateOtpData = {
  validateOtp: boolean | string;
};

export const VALIDATE_OTP_MUTATION = gql`
  mutation ValidateOtp($email: String!, $code: String!) {
    validateOtp(email: $email, code: $code)
  }
`;
